import{jsxs as e,jsx as l}from"react/jsx-runtime";import t from"tailwind-styled-components";import r from"clsx";const a=t.div`
  bg-gray-50
  border
  border-black/5
  inline-flex
  items-center
  justify-center
  rounded-full

  dark:bg-gray-700
`,o=t.span`
  font-semibold
  text-typography-subtle

  dark:text-gray-400
`,s=t.div`
  h-full
  overflow-hidden
  relative
  rounded-full
  w-full
`,n=t.img`
  -translate-x-1/2
  -translate-y-1/2
  absolute
  h-full
  left-1/2
  max-w-none
  top-1/2
`,i=({className:t,initials:i,mugshot:m,size:d="normal",...c})=>{const x=r(t,{"h-5 w-5":"small"===d,"h-8 w-8":"normal"===d,"h-12 w-12":"large"===d,"h-16 w-16":"xlarge"===d}),f=r({"text-[0.5rem]":"small"===d,"text-sm":"normal"===d,"text-base":"large"===d,"text-2xl":"xlarge"===d});return e(a,{...c,className:x,children:[!m&&l(o,{className:f,children:i}),m&&l(s,{children:l(n,{alt:"logo",src:m})})]})};export{i as default};
